import type { ReactNode } from 'react'

export interface TrustItemProps {
  icon: ReactNode
  children: ReactNode
}

export function TrustItem({ icon, children }: TrustItemProps) {
  return (
    <div className="azoya-trust-item">
      <span className="azoya-trust-icon">{icon}</span>
      <span>{children}</span>
    </div>
  )
}
